/**
 * 메인: 카테고리 목록
 *
 *
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Content, Title, ProductItem, Row, Col, Button } from 'components';
import { Button as AntButton } from 'antd';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
// import Roasters from 'assets/roasters.png';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { encrypt } from 'utils/Crypto';

/**----------------------------------------
 * [Component] 쇼핑몰 > 메인 > 신상품 컴포넌트
 * ----------------------------------------
 */
const NewProducts = (props) => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();

  /* ===== PROPS ===== */
  const { products = [], screenSize } = props;

  /* ===== STATE ===== */
  const nextRef = React.useRef(null);
  const prevRef = React.useRef(null);
  // Swiper
  const [swiperObj, setSwiperObj] = useState(null);
  const [newProducts, setNewProducts] = React.useState([]);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  React.useEffect(() => {
    if (!products.length) return;

    // 신상품 목록
    const newProducts = products
      ?.filter((item) => item?.isNew === 'Y')
      ?.sort((a, b) => b?.create - a?.create);

    // 최신상품 5개만 저장
    const newProductList = newProducts.slice(0, 5);
    // const newProductList = newProducts;

    setNewProducts(newProductList);
  }, [products]);

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <div
      style={{
        background: `url("/jm-coffee-roasters-main-01_1920x1130.jpg") center center / cover no-repeat`,
      }}
      className="newproducts"
    >
      <Content
        maxWidth={'100%'}
        backgroundColor="none"
        padding={screenSize >= 768 ? '150px 0' : '40px 0'}
        style={{
          background: 'rgba(0,0,0,0.5)',
        }}
      >
        <Content
          maxWidth={1500}
          backgroundColor="none"
          padding={0}
          style={{
            margin: '0 auto',
            width:
              screenSize >= 768 ? 'calc(100% - 60px)' : 'calc(100% - 30px)',
          }}
        >
          <Title
            style={{
              fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 30 : 26,
              lineHeight: screenSize >= 768 ? '88px' : '150%',
              flexWrap: 'wrap',
            }}
            color="#fff"
            className="dela-gothic"
            subButton={
              <Button
                className={'goto'}
                type="default"
                onClick={() => navigate(`/products?type=new`)}
              >
                바로가기 <RightOutlined />
              </Button>
            }
          >
            Machine & Goods
          </Title>

          <Content
            maxWidth={'100%'}
            padding={screenSize >= 768 ? '50px 32px' : 15}
            style={{
              marginTop: screenSize >= 768 ? 200 : 30,
              borderRadius: 10,
            }}
          >
            <Row>
              {/* === Left button === */}
              <Col
                x={1}
                md={2}
                style={{
                  ...styles.controlBtn,
                  paddingLeft: screenSize >= 500 ? 0 : 10,
                }}
              >
                <div>
                  <AntButton
                    ref={prevRef}
                    onClick={() => swiperObj.slidePrev()}
                    size="large"
                    type="default"
                    shape="circle"
                    style={{ zIndex: 2 }}
                    className="slidebutton"
                  >
                    <LeftOutlined />
                  </AntButton>
                </div>
              </Col>
              <Col x={1} />

              {/* === 상품정보: start === */}

              <Col x={20} md={18}>
                <Swiper
                  slidesPerView={1}
                  loop={true}
                  modules={[Navigation]}
                  onInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                    setSwiperObj(swiper);
                  }}
                >
                  {newProducts.map((_item, _index) => (
                    <SwiperSlide key={`new-product-${_item.key}-${_index}`}>
                      <Content
                        maxWidth={'100%'}
                        //padding={screenSize >= 768 ? 15 : 0}
                        backgroundColor="none"
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          flexDirection: screenSize >= 768 ? 'unset' : 'column',
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          navigate(
                            `/products/${encodeURIComponent(
                              encrypt(_item.key)
                            )}`
                          )
                        }
                      >
                        {/* === 상품정보 === */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            height: '100%',
                            maxWidth: screenSize >= 768 ? '49%' : '100%',
                            overflow: 'hidden',
                            //cursor: 'pointer',
                          }}
                          // onClick={() =>
                          //   navigate(
                          //     `/products/${encodeURIComponent(
                          //       encrypt(_item.key)
                          //     )}`
                          //   )
                          // }
                        >
                          <div
                            style={{ marginTop: screenSize >= 500 ? 24 : 15 }}
                          >
                            <div
                              style={{
                                position: 'relative',
                              }}
                            >
                              <ProductItem.Tags
                                tags={_item.tags.map((_item) => ({
                                  id: _item.tag_id,
                                  label: _item.label,
                                }))}
                                style={{
                                  marginBottom: screenSize >= 768 ? 12 : 20,
                                  fontSize: screenSize >= 768 ? 16 : 14,
                                }}
                              />
                              <div
                                style={{
                                  position: 'absolute',
                                  width: '20%',
                                  height: '100%',
                                  top: 0,
                                  right: 0,
                                  background:
                                    'linear-gradient(to left, white, transparent)',
                                }}
                              ></div>
                            </div>
                            <ProductItem.Title
                              title={_item.brand}
                              style={{
                                fontSize: screenSize >= 768 ? 20 : 14,
                                marginTop: 0,
                              }}
                            />
                            <ProductItem.Title
                              title={_item.title}
                              style={{
                                fontSize:
                                  screenSize >= 1200
                                    ? 32
                                    : screenSize >= 768
                                    ? 28
                                    : 18,
                                marginTop: screenSize >= 768 ? 10 : 4,
                              }}
                            />
                            <ProductItem.Review
                              review={{
                                score: _item.score,
                                comment: _item.comment,
                              }}
                              style={{ marginTop: screenSize >= 768 ? 16 : 0 }}
                            />
                            {/* <ProductItem.Title
                              title={'24,000원'}
                              style={{ fontSize: '1.85em' }}
                            /> */}
                            <ProductItem.Price
                              price={_item.price}
                              discount={_item.discount}
                              type={_item.discount_type}
                              discountPrice={_item.finalPrice}
                              unit={'원'}
                              style={{
                                marginTop: screenSize >= 768 ? 30 : 16,
                                fontSize:
                                  screenSize >= 1200
                                    ? 40
                                    : screenSize >= 768
                                    ? 30
                                    : 20,
                                whiteSpace: 'no-wrap',
                              }}
                              policies={_item.policies}
                            />
                          </div>

                          {/* <div
                            style={{ marginTop: screenSize >= 500 ? 52 : 20 }}
                          >
                            <Button
                              className="dela-gothic"
                              style={{
                                padding:
                                  screenSize >= 768 ? '18px 52px' : '8px 20px',
                                fontSize: screenSize >= 768 ? 14 : 12,
                                minWidth: 117,
                              }}
                              onClick={() =>
                                navigate(
                                  `/products/${encodeURIComponent(
                                    encrypt(_item.key)
                                  )}`
                                )
                              }
                            >
                              View detail
                            </Button>
                          </div> */}
                        </div>

                        {/* === 상품이미지 === */}
                        <div
                          style={{
                            maxWidth: screenSize >= 768 ? '49%' : '100%',
                            width: screenSize >= 768 ? 'unset' : '100%',
                            height: screenSize >= 768 ? 'unset' : '88.7vw',
                            display: screenSize >= 768 ? 'unset' : 'flex',
                            justifyContent:
                              screenSize >= 768 ? 'unset' : 'center',
                            alignItems: screenSize >= 768 ? 'unset' : 'center',
                            marginTop: screenSize >= 768 ? 0 : 20,
                            overflow: 'hidden',
                          }}
                        >
                          <div
                            style={{
                              width: '100%',
                              height: '100%',
                              //height: screenSize >= 500 ? '100%' : '80%',
                              transformOrigin: `bottom right`,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <ProductItem.Image
                              src={_item.src}
                              title={_item.title}
                              isSoldOut={_item.isSoldOut === 'Y' ? true : false}
                              hovered={false}
                              icons={[
                                ...(_item.isBest === 'Y'
                                  ? [
                                      {
                                        label: 'BEST',
                                        color: 'rgb(202, 97, 98)',
                                      },
                                    ]
                                  : []),
                                {
                                  label: 'NEW',
                                  color: 'rgb(56, 56, 56)',
                                },
                              ]}
                            />
                          </div>
                        </div>
                      </Content>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
              {/* === 상품정보: end === */}

              <Col x={1} />
              {/* === Right button === */}
              <Col
                x={1}
                md={2}
                style={{
                  ...styles.controlBtn,
                  paddingRight: screenSize >= 500 ? 0 : 10,
                }}
              >
                <div>
                  <AntButton
                    size="large"
                    type="default"
                    shape="circle"
                    ref={nextRef}
                    onClick={() => swiperObj.slideNext()}
                    s
                    style={{ zIndex: 2 }}
                    className="slidebutton"
                  >
                    <RightOutlined />
                  </AntButton>
                </div>
              </Col>
            </Row>
          </Content>
        </Content>
      </Content>
    </div>
  ); // JSX: end
};

const styles = {
  controlBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default NewProducts;
